import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'

export const formInputGroup = (theme: Theme): SerializedStyles =>
  css({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    marginLeft: `-${theme.spacing(3)}`,
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  })

export const formColumn = (theme: Theme): SerializedStyles =>
  css({
    '& + &': {
      marginTop: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        marginTop: 0,
      },
    },
    flexDirection: 'column',
    paddingLeft: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      flex: 1,
    },
  })

export const resetFieldset = css({
  border: 0,
  marginInline: 0,
  minWidth: 0,
  padding: 0,
  paddingBlock: 0,
  paddingInline: 0,
})

export const resetLegend = css({
  paddingInline: 0,
  width: '100%',
})
